
import pageMixin from '@bkwld/cloak/mixins/page'
sdk = 'https://boards.greenhouse.io/embed/job_board/js?for=nuro'
export default

	mixins: [ pageMixin ]

	head: -> @buildHead {
		title: 'Work at Nuro'
		image: '/nuro_logo_dark.png'
	}

	data: ->
		# Add a @page object.
		# Without this, cloak buildHead() won't add our og:title and og:image.
		page: {}

	# Set header to be dark
	asyncData: ({ store }) -> store.commit 'tower/setLightMarquee', true

	# Add the script late, it needs to come after div is rendered. And cache
	# bust it so it's fetched anew on client side navigation
	mounted: ->
		await @$loadScript sdk
		Grnhse.Iframe.load()
	
		# Update scroll bar after rendering finishes
		@$wait 1000, => @$scroller.update()
		@$wait 5000, => @$scroller.update()

